import React, { useState, useEffect } from 'react';
import './Favorite.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import axios from 'axios';

const Favorites = () => {
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);
  // const [quantities, setQuantities] = useState({});
  const [cart, setCart] = useState([]); // You can also manage this state in a global store (like Redux)
  const [quantities, setQuantities] = useState({});
  useEffect(() => {
    const fetchFavorites = async () => {
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("authToken"); // ✅ get auth token

      if (!userId) {
        console.error("User ID not found in localStorage.");
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(
          `https://backend.maamaas.com/food/favourite/getallbyuserid/${userId}`,
          {
            headers: token ? { Authorization: `Bearer ${token}` } : {},
          }
        );
        if (!response.ok) throw new Error("Failed to fetch favorites");

        const data = await response.json();
        console.log("Favorite Dishes:", data);

        setFavorites(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFavorites();
  }, []);




  const addToCart = async (item, quantity) => {
    console.log('addToCart called with dishId:', item.dishId);

    const userId = localStorage.getItem("userId");

    if (!userId) {
      alert("❌ User ID not found. Please log in again.");
      return;
    }

    const apiUrl = `http://10.10.20.9:7007/Mamaswebsite-0.0.1-SNAPSHOT/cart/add/${userId}`;

    const data = {
      dishId: item.dishId,
      quantity: quantity,
      price: (item.price * 0.9).toFixed(2), // 10% discount
    };

    try {
      const response = await axios.post(apiUrl, data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 200) {
        console.log('Item successfully added to cart:', response.data);

        setCart((prevCart) => {
          const updatedCart = [...prevCart, { ...item, quantity }];
          return updatedCart;
        });
      } else {
        console.error('Failed to add item to cart:', response.data);
        alert('Failed to add item to cart. Please try again.');
      }
    } catch (error) {
      console.error('Error adding item to cart:', error);

      if (error.response) {
        console.error('Server Response:', error.response.data);
        alert(`Server error: ${error.response.status} - ${error.response.data.message || 'Please try again later.'}`);
      } else if (error.request) {
        console.error('No response received:', error.request);
        alert('No response from server. Please try again later.');
      } else {
        console.error('Error message:', error.message);
        alert(`Unexpected error: ${error.message}`);
      }
    }
  };


  const increaseQuantity = (id) => {
    setQuantities((prevQuantities) => {
      const newQuantities = { ...prevQuantities, [id]: prevQuantities[id] + 1 };
      return newQuantities;
    });
  };

  const decreaseQuantity = (id) => {
    setQuantities((prevQuantities) => {
      const newQuantities = { ...prevQuantities, [id]: Math.max(prevQuantities[id] - 1, 0) };
      return newQuantities;
    });
  };
  const handleAddToCart = (id) => {
    setQuantities((prev) => ({ ...prev, [id]: 1 }));
  };

  return (
    <div className="favorites-container" style={{ marginTop: "-5px" }}>
      {loading ? (
        <div>Loading...</div>
      ) : (
        favorites.map((item) => (
          <div key={item.dishId} className="favorites-card">
            <div className="favorites-inner-box">
              {/* Display the image or a default image if not available */}
              {item.dishImage ? (
                <img
                  src={item.dishImage}
                  alt="Dish"
                  className="offer-image"
                />
              ) : (
                <img
                  src="default-image.jpg"
                  alt="Default"
                  className="offer-image"
                />
              )}
            </div>

            <div className="favorites-card-body">
              <h5 className="favorites-card-title">{item.dishName}</h5>

              <div className="d-flex justify-content-between">
                <div>
                  <span>
                    {/* <span className="discounted-price">₹{(item.price * 0.9).toFixed(2)}</span> */}
                    <span>
                      <span style={{ fontSize: '20px', position: 'relative' }}>
                        <i className="fa-solid fa-indian-rupee-sign" style={{ fontSize: "15px" }}></i>
                        {(item.price * 0.9).toFixed(2)}

                      </span>
                      {/* <i className="fa-solid fa-indian-rupee-sign"></i> */}
                      <span style={{ position: 'relative', marginLeft: '15px', fontSize: '21px', color: "gray" }}>
                        <i className="fa-solid fa-indian-rupee-sign" style={{ fontSize: '15px' }}></i>
                        {item.price}
                        <span style={{
                          content: '',
                          position: 'absolute',
                          top: '15px',
                          left: 0,
                          width: '100%',
                          borderTop: '1px solid black',
                        }} />
                      </span>

                    </span>
                    {/* <i
                      className="fa-regular fa-heart fs-5"
                      style={{ marginTop: '10px', cursor: 'pointer' }}
                      // onClick={() => handleAddToFavorites(item.dishId)} // Call the function when heart icon is clicked
                    /> */}
                  </span>
                </div>
                <i
                  className="fa-solid fa-heart fs-5"
                  style={{ marginTop: '10px', cursor: 'pointer', color: 'red' }}
                />

                {/* <i className="fa-solid fa-heart fs-5" style={{ color: 'red' }}></i> */}
              </div>

              {quantities[item.dishId] > 0 ? (
                <div
                  className="d-flex justify-content-between align-items-center border p-2 mt-2"
                  style={{
                    borderRadius: '50px',
                    backgroundColor: '#b15dc6',
                    width: '190px',
                    height: '37px',
                    marginLeft: '38px',
                  }}
                >
                  <button
                    className="btn"
                    onClick={() => {
                      decreaseQuantity(item.dishId);
                      // openModal(item);
                      addToCart(item, quantities[item.dishId] - 1); // Decrease quantity in API
                    }}
                    style={{
                      width: '40px',
                      height: '40px',
                      fontWeight: 'bold',
                      fontSize: '25px',
                      color: '#fff',
                      marginTop: '-10px',
                      border: '#fff',
                    }}
                  >
                    -
                  </button>

                  <span
                    style={{
                      fontSize: '25px',
                      fontWeight: 'bold',
                      minWidth: '40px',
                      textAlign: 'center',
                      color: '#fff',
                    }}
                  >
                    {quantities[item.dishId]}
                  </span>

                  <button
                    className="btn"
                    onClick={() => {
                      increaseQuantity(item.dishId);
                      // openModal(item);
                      addToCart(item, quantities[item.dishId] + 1); // Increase quantity in API
                    }}
                    style={{
                      width: '40px',
                      height: '40px',
                      fontSize: '25px',
                      fontWeight: 'bold',
                      color: '#fff',
                      marginTop: '-10px',
                      border: '#fff',
                    }}
                  >
                    +
                  </button>
                </div>
              ) : (
                <button
                  className="btn w-90 mt-2"
                  onClick={() => {
                    // openModal(item);
                    setQuantities((prevQuantities) => ({
                      ...prevQuantities,
                      [item.dishId]: 1,
                    }));
                    addToCart(item, 1); // Add item with quantity 1 to the API
                  }}
                  style={{
                    width: '190px',
                    background: '#b15dc6',
                    marginLeft: '38px',
                    color: '#fff',
                  }}
                >
                  Add To Cart
                </button>
              )}
            </div>
          </div>
        ))
      )}
      <div
        style={{
          position: "fixed",
          bottom: "0px",
          left: "0px",
          height: '30px',
          width: "100%",
          backgroundColor: "white",
          color: "black",
          textAlign: "center",
          padding: "5px",
          fontWeight: "bold",
          fontSize: "14px",
          boxShadow: "0 -2px 5px rgba(0, 0, 0, 0.1)",
          zIndex: "999"
        }}
      >
        @Envision Integrated Services Pvt Ltd - Empowering Your Future 🚀
      </div>
    </div >
  );
};

export default Favorites;
